import { PaginationAdapter } from '@red/data-access';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ProjectReportModel } from '@shared/data-access/models';
import { ProjectReportAction } from '../actions';

export const featureName = 'projectReport';

export interface ProjectReportState {
  item: ProjectReportModel | null;
  dataSource: PaginationAdapter<ProjectReportModel> | null;
}
export const initialState: ProjectReportState = {
  item: null,
  dataSource: null,
};
export const projectReportFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(ProjectReportAction.loadItemSuccess, (state, prop: { item: ProjectReportModel }) => ({ ...state, item: prop.item })),
    on(ProjectReportAction.loadItemsSuccess, (state, prop: { data: PaginationAdapter<ProjectReportModel> }) => ({ ...state, dataSource: prop.data }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = projectReportFeature;
